import { IMenuItem } from 'projects/shared/src/lib/models/menu.model';

export const claimMenu: IMenuItem = {
  label: `Claim`,
  path: `claim-desk`,
  id: 'MID_CLAIM_DESK',
  icon: 'fa fa-ticket',
  children: [
    {
      path: `find`,
      label: `Claim Data`,
      id: 'MID_CLAIM_FIND',
    },
    { path: `health`, label: `Health`, id: 'MID_CLAIM_HEALTH' },
    { path: `catastrophe`, label: `Catastrophe`, id: 'MID_CLAIM_CATASTROPHE' },
    { path: `third-party`, label: `Third Party`, id: 'MID_CLAIM_THIRD_PARTY' },
    {
      label: 'Triangles',
      id: 'MID_CLAIM_TRIANGLES',
      children: [
        {
          path: 'triangles/accident-on-reporting',
          label: 'Accident On Reporting',
          id: 'MID_CLAIM_TRIANGLES_ACCIDENT_ON_REPORTING',
        },
      ],
    },
  ],
};
